module.exports = __webpack_public_path__ + "img/pop-snow.1ca889be.png";